/**
 * Accessibility Enhancements
 * Adds contextual aria-labels to "Learn more" links in schema settings
 */
(function() {
  'use strict';

  function enhanceLearnMoreLinks() {
    // Find all links containing "Learn more" text
    const learnMoreLinks = Array.from(document.querySelectorAll('a')).filter(link => {
      const text = link.textContent.trim().toLowerCase();
      return text.includes('learn more') || text === 'learn more';
    });

    learnMoreLinks.forEach(link => {
      // Skip if already has aria-label
      if (link.hasAttribute('aria-label')) {
        return;
      }

      // Try to extract context from surrounding elements
      let context = '';
      
      // Check parent paragraph or info element
      const parent = link.closest('p, .info, [class*="info"], [class*="description"]');
      if (parent) {
        const parentText = parent.textContent.trim();
        // Extract topic from parent text (before "Learn more")
        const match = parentText.match(/^([^[\(]*?)(?:\s*\[?Learn more)/i);
        if (match && match[1]) {
          context = match[1].trim();
        }
      }

      // Check previous sibling for context
      if (!context && link.previousSibling) {
        const prevText = link.previousSibling.textContent;
        if (prevText) {
          context = prevText.trim().replace(/[\.:]\s*$/, '');
        }
      }

      // Check parent's previous sibling
      if (!context && link.parentElement && link.parentElement.previousElementSibling) {
        const prevSibling = link.parentElement.previousElementSibling;
        const prevText = prevSibling.textContent.trim();
        if (prevText && prevText.length < 200) {
          context = prevText.replace(/[\.:]\s*$/, '');
        }
      }

      // Fallback: use link's href to infer topic
      if (!context && link.href) {
        try {
          const url = new URL(link.href);
          const pathParts = url.pathname.split('/').filter(p => p);
          if (pathParts.length > 0) {
            context = pathParts[pathParts.length - 1].replace(/-/g, ' ');
          }
        } catch (e) {
          // Invalid URL, skip
        }
      }

      // Create aria-label
      if (context) {
        link.setAttribute('aria-label', `Learn more about ${context}`);
      } else {
        link.setAttribute('aria-label', 'Learn more');
      }
    });
  }

  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceLearnMoreLinks);
  } else {
    enhanceLearnMoreLinks();
  }

  // Also run after dynamic content loads (for theme editor)
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function(mutations) {
      let shouldEnhance = false;
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          shouldEnhance = true;
        }
      });
      if (shouldEnhance) {
        enhanceLearnMoreLinks();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();
